import { createAction, props } from '@ngrx/store';
import { EventStatistic } from '../../models/statistic';

export enum StatisticActionTypes {
  LoadEventStatistic = '[Event Statistic] Get Event Statistic',
  LoadEventStatisticSuccess = '[Event Statistic] Get Event Statistic Success',
  LoadEventStatisticError = '[Event Statistic] Get Event Statistic Error',
  EventStatisticCleanup = '[Event Statistic] Event Cleanup',
}

export const getEventStatistic = createAction(
  StatisticActionTypes.LoadEventStatistic,
  props<{ eventId: string }>(),
);

export const getEventStatisticSuccess = createAction(
  StatisticActionTypes.LoadEventStatisticSuccess,
  props<{ eventStatistic: EventStatistic }>(),
);

export const getEventStatisticError = createAction(
  StatisticActionTypes.LoadEventStatisticError,
  props<{ errorMessage: string }>(),
);

export const cleanUpEventStatistic = createAction(
  StatisticActionTypes.EventStatisticCleanup,
);
